// Level 4's copy (#219): the specialisations, the mock week and its badges, the twelve-wine paper, the
// theory essay and the research prompt, in our own words in nl and en. Nothing
// here names an outside body, a price, a pass or a fail, a provider, a retention rule or a confidence.
// i18n.ts spreads these into the two dictionaries; the other five locales read Dutch.
export const masteryCopy = {
  nl: {
    "learn.l4.title": "Meesterschap",
    "learn.l4.level-title": "Niveau 4",
    "learn.l4.locked": "Niveau 4 en de specialisaties gaan open zodra niveau 3 is afgerond.",
    "learn.tracks.title": "Specialisaties",
    "learn.tracks.hint": "Kies er één of meer; je kunt altijd beginnen met de eerste les.",
    "learn.tracks.sommelier": "Sommelier",
    "learn.tracks.sommelier-body": "Bediening, wijnkaart en kelder voor het vak.",
    "learn.tracks.mw": "Meesterroute",
    "learn.tracks.mw-body": "Twaalf wijnen, theorie en een proefweek.",
    "learn.tracks.viticulturist": "Wijnbouwer",
    "learn.tracks.viticulturist-body": "De wijngaard van grond tot oogst.",
    "learn.tracks.oenologist": "Wijnmaker",
    "learn.tracks.oenologist-body": "De kelder van gisting tot fles.",
    "learn.tracks.enrol": "Doe mee",
    "learn.tracks.enrolled": "Je doet mee",
    "learn.tracks.locked": "Gaat open na niveau 3.",
    "learn.tracks.first-lesson": "Begin met de eerste les",
    "learn.tracks.no-lessons": "De lessen van deze route volgen; je hoeft nu niets te doen.",
    "learn.tracks.meter": "{track}: {value} procent",
    "learn.tracks.since": "Sinds {date}",
    "learn.week.link": "Proefweek",
    "learn.week.link-hint": "Drie papers op drie dagen achter elkaar",
    "learn.week.title": "Proefweek",
    "learn.week.intro":
      "Drie papers met twaalf wijnen op drie dagen achter elkaar. Je kiest zelf wanneer je begint; er wordt niets voor je gepland.",
    "learn.week.pick-day": "Eerste dag",
    "learn.week.start": "Plan de proefweek",
    "learn.week.past": "Kies een dag vanaf vandaag.",
    "learn.week.day": "Dag {n}",
    "learn.week.status-sat": "Gezeten",
    "learn.week.status-today": "Vandaag",
    "learn.week.status-upcoming": "Gepland",
    "learn.week.status-open": "Nog niet gezeten",
    "learn.week.sit": "Zit dit paper",
    "learn.week.resume": "Ga verder met het paper",
    "learn.week.result": "Bekijk de uitslag",
    "learn.week.no-paper": "Dit paper staat nog niet klaar.",
    "learn.week.move": "Verplaats de rest",
    "learn.week.move-day": "Nieuwe eerste dag voor de rest",
    "learn.week.move-do": "Verplaats",
    "learn.week.cancel": "Stop de proefweek",
    "learn.week.cancelled": "Gestopt. Wat je zat en je badges blijven bewaard.",
    "learn.week.new": "Plan een nieuwe proefweek",
    "learn.week.badges": "Je badges",
    "learn.week.badges-empty": "Nog geen badges. Ze komen na een nagekeken dag.",
    "learn.week.badge-new": "Nieuwe badge: {label}",
    "learn.l4.papers-title": "Papers en essays",
    "learn.l4.papers-hint": "Twaalf wijnen op tijd, of een essay over de theorie.",
    "learn.l4.essay-open": "Schrijf dit essay",
    "learn.l4.paper-open": "Zit dit paper",
    "learn.l4.paper-label": "Paper met twaalf wijnen",
    "learn.wines.title": "Twaalf wijnen",
    "learn.wines.locked": "Dit paper gaat open zodra niveau 3 is afgerond.",
    "learn.wines.none-title": "Nog geen paper",
    "learn.wines.none-body": "Er staat nu geen paper met twaalf wijnen klaar.",
    "learn.wines.ready-title": "Een paper met twaalf wijnen",
    "learn.wines.fact-pour": "Twaalf wijnen van 5 cl, of zes per helft.",
    "learn.wines.fact-spit": "Spuug elke wijn uit; proeven hoeft niet te betekenen dat je drinkt.",
    "learn.wines.fact-time": "{m} minuten per deel, op de klok van je toestel.",
    "learn.wines.fact-flights": "{n} reeksen met één vraag per reeks.",
    "learn.wines.mode": "Hoe zit je het?",
    "learn.wines.mode-exam": "In één keer",
    "learn.wines.mode-practice": "In twee avonden",
    "learn.wines.mode-practice-note":
      "Twee helften van zes wijnen; de tweede kan binnen zeven dagen.",
    "learn.wines.context": "Met wie?",
    "learn.wines.context-solo": "Alleen",
    "learn.wines.context-flight": "Met vrienden",
    "learn.wines.context-school": "In een groep of les",
    "learn.wines.pour-title": "Schenk deze stijlen",
    "learn.wines.pour-note": "Een stijl, geen fles: elke wijn van die stijl is goed.",
    "learn.wines.start": "Begin het paper",
    "learn.wines.resume": "Ga verder met het paper",
    "learn.wines.flight": "Reeks {n}",
    "learn.wines.wine": "Wijn {n}",
    "learn.wines.field-grape": "Druif",
    "learn.wines.field-country": "Land",
    "learn.wines.field-region": "Streek",
    "learn.wines.field-vintage": "Jaargang",
    "learn.wines.field-quality": "Kwaliteit",
    "learn.wines.field-commercial": "Commerciële positie",
    "learn.wines.field-ageing": "Rijping",
    "learn.wines.field-quality-chips": "Waarom die kwaliteit?",
    "learn.wines.field-ageing-chips": "Waarom die rijping?",
    "learn.wines.field-text": "Je betoog in eigen woorden (mag leeg)",
    "learn.wines.none": "Geen keuze",
    "learn.wines.commercial-entry": "Instap",
    "learn.wines.commercial-mid": "Midden",
    "learn.wines.commercial-premium": "Premium",
    "learn.wines.ageing-now": "Nu drinken",
    "learn.wines.ageing-medium": "Enkele jaren",
    "learn.wines.ageing-long": "Lang te bewaren",
    "learn.wines.answered": "{n} van {total} wijnen beantwoord",
    "learn.wines.hand-in": "Lever in",
    "learn.wines.hand-in-ask": "{n} wijnen zijn nog leeg. Lever in wat er is?",
    "learn.wines.hand-in-yes": "Lever in",
    "learn.wines.hand-in-back": "Terug naar het paper",
    "learn.wines.closed": "De tijd is om; wat er stond is ingeleverd.",
    "learn.wines.abandon": "Stop zonder uitslag",
    "learn.wines.result-title": "Uitslag",
    "learn.wines.result-halves": "{sat} van {of} helften",
    "learn.wines.result-second-half": "Zit de tweede helft",
    "learn.wines.section-identification": "Herkennen",
    "learn.wines.section-quality": "Kwaliteit in de markt",
    "learn.wines.section-ageing": "Rijping",
    "learn.wines.section-argument": "Het betoog",
    "learn.wines.right": "Goed",
    "learn.wines.near": "Dichtbij",
    "learn.wines.missed": "Gemist",
    "learn.wines.empty": "Niet ingevuld",
    "learn.wines.key": "Zo zat de wijn in elkaar: {style}",
    "learn.wines.marking-pending":
      "Het betoog wordt nagekeken zodra het kan; je antwoord is bewaard.",
    "learn.wines.marking-signed-out":
      "Log in om je betoog te laten nakijken; je kunt het ook zelf nalopen.",
    "learn.wines.marking-quota": "Het nakijken is voor nu op; het komt later terug.",
    "learn.wines.self-check": "Loop het zelf na",
    "learn.wines.self-met": "Behandeld",
    "learn.wines.self-partly": "Deels",
    "learn.wines.self-not-yet": "Nog niet",
    "learn.wines.criterion-c1": "Een kwaliteitsconclusie met bewijs uit het glas",
    "learn.wines.criterion-c2": "De wijn in de markt geplaatst",
    "learn.wines.criterion-c3": "Een rijpingsvisie met reden",
    "learn.wines.criterion-c4": "Herkenning en betoog verbonden",
    "learn.wines.criterion-c5": "Het zwakste punt of een tegenwicht",
    "learn.wines.lost-points": "{n} punten gemist op {field}",
    "learn.essay.title": "Theorie-essay",
    "learn.essay.none": "Dit essay staat nog niet klaar.",
    "learn.essay.chosen": "De vraag",
    "learn.essay.write": "Schrijf je antwoord",
    "learn.essay.hand-in": "Lever in",
    "learn.essay.words": "{n} woorden",
    "learn.essay.empty": "Schrijf eerst iets; zonder tekst valt er niets na te kijken.",
    "learn.essay.result": "Zo liep je betoog",
    "learn.essay.quote": "Jouw woorden: {quote}",
    "learn.essay.pending": "Het essay wordt nagekeken zodra het kan; je tekst is bewaard.",
    "learn.essay.signed-out": "Log in om je essay te laten nakijken.",
    "learn.research.title": "Onderzoeksopdracht",
    "learn.research.none": "Deze opdracht staat nog niet klaar.",
    "learn.research.datasets": "Gegevens uit druif: {sets}",
    "learn.research.write": "Je onderzoekje",
    "learn.research.rubric": "Loop je eigen werk na",
    "learn.research.met": "Gelukt",
    "learn.research.submit": "Klaar",
    "learn.research.done": "Bewaard op dit toestel; {met} van {total} punten gelukt.",
    "learn.research.on-device": "Je tekst blijft op dit toestel.",
    "learn.research.attribution": "Weergegevens: Open-Meteo, onder CC BY 4.0.",
    "learn.research.again": "Beantwoord opnieuw",
  },
  en: {
    "learn.l4.title": "Mastery",
    "learn.l4.level-title": "Level 4",
    "learn.l4.locked": "Level 4 and the specialisations open as soon as Level 3 is complete.",
    "learn.tracks.title": "Specialisations",
    "learn.tracks.hint": "Pick one or more; you can always start with the first lesson.",
    "learn.tracks.sommelier": "Sommelier",
    "learn.tracks.sommelier-body": "Service, the wine list and the cellar, for the trade.",
    "learn.tracks.mw": "Master route",
    "learn.tracks.mw-body": "Twelve wines, theory and a mock week.",
    "learn.tracks.viticulturist": "Viticulturist",
    "learn.tracks.viticulturist-body": "The vineyard from soil to harvest.",
    "learn.tracks.oenologist": "Winemaker",
    "learn.tracks.oenologist-body": "The cellar from fermentation to bottle.",
    "learn.tracks.enrol": "Join",
    "learn.tracks.enrolled": "You are in",
    "learn.tracks.locked": "Opens after Level 3.",
    "learn.tracks.first-lesson": "Start with the first lesson",
    "learn.tracks.no-lessons": "This route's lessons are coming; there is nothing to do yet.",
    "learn.tracks.meter": "{track}: {value} percent",
    "learn.tracks.since": "Since {date}",
    "learn.week.link": "Mock week",
    "learn.week.link-hint": "Three papers on three days in a row",
    "learn.week.title": "Mock week",
    "learn.week.intro":
      "Three twelve-wine papers on three days in a row. You choose when to begin; nothing is scheduled for you.",
    "learn.week.pick-day": "First day",
    "learn.week.start": "Plan the mock week",
    "learn.week.past": "Pick a day from today on.",
    "learn.week.day": "Day {n}",
    "learn.week.status-sat": "Sat",
    "learn.week.status-today": "Today",
    "learn.week.status-upcoming": "Planned",
    "learn.week.status-open": "Not yet sat",
    "learn.week.sit": "Sit this paper",
    "learn.week.resume": "Carry on with the paper",
    "learn.week.result": "See the result",
    "learn.week.no-paper": "This paper is not ready yet.",
    "learn.week.move": "Move the rest",
    "learn.week.move-day": "New first day for the rest",
    "learn.week.move-do": "Move",
    "learn.week.cancel": "Stop the mock week",
    "learn.week.cancelled": "Stopped. What you sat and your badges are kept.",
    "learn.week.new": "Plan a new mock week",
    "learn.week.badges": "Your badges",
    "learn.week.badges-empty": "No badges yet. They come after a marked day.",
    "learn.week.badge-new": "New badge: {label}",
    "learn.l4.papers-title": "Papers and essays",
    "learn.l4.papers-hint": "Twelve wines against the clock, or an essay on the theory.",
    "learn.l4.essay-open": "Write this essay",
    "learn.l4.paper-open": "Sit this paper",
    "learn.l4.paper-label": "Paper of twelve wines",
    "learn.wines.title": "Twelve wines",
    "learn.wines.locked": "This paper opens as soon as Level 3 is complete.",
    "learn.wines.none-title": "No paper yet",
    "learn.wines.none-body": "There is no twelve-wine paper ready right now.",
    "learn.wines.ready-title": "A paper of twelve wines",
    "learn.wines.fact-pour": "Twelve 5 cl pours, or six a half.",
    "learn.wines.fact-spit": "Spit every wine; tasting does not have to mean drinking.",
    "learn.wines.fact-time": "{m} minutes a part, on your device's clock.",
    "learn.wines.fact-flights": "{n} flights with one question each.",
    "learn.wines.mode": "How do you sit it?",
    "learn.wines.mode-exam": "In one go",
    "learn.wines.mode-practice": "Over two evenings",
    "learn.wines.mode-practice-note":
      "Two halves of six wines; the second can follow within seven days.",
    "learn.wines.context": "With whom?",
    "learn.wines.context-solo": "Alone",
    "learn.wines.context-flight": "With friends",
    "learn.wines.context-school": "In a group or class",
    "learn.wines.pour-title": "Pour these styles",
    "learn.wines.pour-note": "A style, not a bottle: any wine of that style serves.",
    "learn.wines.start": "Begin the paper",
    "learn.wines.resume": "Carry on with the paper",
    "learn.wines.flight": "Flight {n}",
    "learn.wines.wine": "Wine {n}",
    "learn.wines.field-grape": "Grape",
    "learn.wines.field-country": "Country",
    "learn.wines.field-region": "Region",
    "learn.wines.field-vintage": "Vintage",
    "learn.wines.field-quality": "Quality",
    "learn.wines.field-commercial": "Commercial position",
    "learn.wines.field-ageing": "Ageing",
    "learn.wines.field-quality-chips": "Why that quality?",
    "learn.wines.field-ageing-chips": "Why that ageing?",
    "learn.wines.field-text": "Your argument in your own words (may be empty)",
    "learn.wines.none": "No call",
    "learn.wines.commercial-entry": "Entry",
    "learn.wines.commercial-mid": "Mid",
    "learn.wines.commercial-premium": "Premium",
    "learn.wines.ageing-now": "Drink now",
    "learn.wines.ageing-medium": "A few years",
    "learn.wines.ageing-long": "Keeps long",
    "learn.wines.answered": "{n} of {total} wines answered",
    "learn.wines.hand-in": "Hand in",
    "learn.wines.hand-in-ask": "{n} wines are still empty. Hand in what there is?",
    "learn.wines.hand-in-yes": "Hand in",
    "learn.wines.hand-in-back": "Back to the paper",
    "learn.wines.closed": "Time is up; what was there has been handed in.",
    "learn.wines.abandon": "Stop without a result",
    "learn.wines.result-title": "Result",
    "learn.wines.result-halves": "{sat} of {of} halves",
    "learn.wines.result-second-half": "Sit the second half",
    "learn.wines.section-identification": "Identifying",
    "learn.wines.section-quality": "Quality in the market",
    "learn.wines.section-ageing": "Ageing",
    "learn.wines.section-argument": "The argument",
    "learn.wines.right": "Right",
    "learn.wines.near": "Close",
    "learn.wines.missed": "Missed",
    "learn.wines.empty": "Not filled in",
    "learn.wines.key": "How the wine stood: {style}",
    "learn.wines.marking-pending":
      "The argument is marked as soon as it can be; your answer is kept.",
    "learn.wines.marking-signed-out":
      "Sign in to have your argument marked; you can also go through it yourself.",
    "learn.wines.marking-quota": "Marking is used up for now; it comes back later.",
    "learn.wines.self-check": "Go through it yourself",
    "learn.wines.self-met": "Covered",
    "learn.wines.self-partly": "Partly",
    "learn.wines.self-not-yet": "Not yet",
    "learn.wines.criterion-c1": "A quality conclusion with evidence from the glass",
    "learn.wines.criterion-c2": "The wine placed in the market",
    "learn.wines.criterion-c3": "An ageing view with a reason",
    "learn.wines.criterion-c4": "Identification and argument connected",
    "learn.wines.criterion-c5": "The weakest point or a counterpoint",
    "learn.wines.lost-points": "{n} points missed on {field}",
    "learn.essay.title": "Theory essay",
    "learn.essay.none": "This essay is not ready yet.",
    "learn.essay.chosen": "The question",
    "learn.essay.write": "Write your answer",
    "learn.essay.hand-in": "Hand in",
    "learn.essay.words": "{n} words",
    "learn.essay.empty": "Write something first; with no text there is nothing to mark.",
    "learn.essay.result": "How your argument went",
    "learn.essay.quote": "Your words: {quote}",
    "learn.essay.pending": "The essay is marked as soon as it can be; your text is kept.",
    "learn.essay.signed-out": "Sign in to have your essay marked.",
    "learn.research.title": "Research task",
    "learn.research.none": "This task is not ready yet.",
    "learn.research.datasets": "Data from druif: {sets}",
    "learn.research.write": "Your small study",
    "learn.research.rubric": "Go through your own work",
    "learn.research.met": "Done",
    "learn.research.submit": "Finished",
    "learn.research.done": "Kept on this device; {met} of {total} points done.",
    "learn.research.on-device": "Your text stays on this device.",
    "learn.research.attribution": "Weather data: Open-Meteo, under CC BY 4.0.",
    "learn.research.again": "Answer again",
  },
} as const;
